export default defineNuxtPlugin(() => {
  if (process.server) return;

  const profileStore = useProfileStore();
  
  // Function to push user_id to dataLayer for GTM
  const pushUserIdToDataLayer = (userId: string) => {
    if (typeof window !== 'undefined' && window.dataLayer) {
      window.dataLayer.push({
        'event': 'user_id_set',
        'user_id': userId
      });
    }
  };

  // Watch for profile changes and push user_id to dataLayer
  watch(
    () => profileStore.profile?.id,
    (userId) => {
      if (userId && profileStore.isLoggedIn) {
        // Small delay to ensure GTM is loaded
        setTimeout(() => {
          pushUserIdToDataLayer(userId);
        }, 2000);
      }
    },
    { immediate: true }
  );
}); 